<div *ngIf="open"
     class="menu officeHome-callout {{ menuModel.cssClass }}"
     [ngClass]="{ 'menu--right' : menuModel.rightAligned && !leftAlignedCard, 'menu--center': menuModel.centerAligned, 'menu--bottom' : menuModel.bottomAligned, 'context-menu--mobile': mobileMenu }"
     [attr.aria-label]="menuAriaLabel"
     [@openAndClose]="animationState"
     (@openAndClose.done)="onAnimationCompleted($event)">
    <ul id="{{ menuModel.id }}-dropdown"
        class="officeHome-callout-main menu__content ms-bgc-w"
        aria-haspopup="true"
        [attr.role]="ariaRole === 'menuitemcheckbox' || ariaRole === 'radio' ? 'menu' : 'listbox'"
        [attr.aria-label]="menuAriaLabel">
        <li *ngFor="let item of menuModel.items; let idx = index; trackBy: trackById"
            [id]="getIdForItem(item)"
            class="menu-item ms-bgc-g40-h ms-bgc-w ms-bgc-g40-f ms-bgc-g40-a {{ item.cssClass }}"
            [ngClass]="{ 'menu-item--mobile': mobileMenu }"
            (click)="onSelectItem(item, idx, $event)"
            (mouseenter)="setActiveIndex(idx)"
            (keydown)="handleKey($event)"
            [attr.aria-label]="item.ariaLabel"
            [attr.aria-describedby]="item.ariaDescribedBy"
            tabindex="-1"
            [attr.role]="ariaRole"
            [attr.data-clicklog]="menuModel.customLogging ? 'custom' : ''"
            [attr.data-area]="menuModel.customLogging ? '' : menuModel.hostComponentArea"
            [attr.aria-posinset]="idx + 1"
            [attr.aria-setsize]="menuModel.items.length"
            [attr.aria-selected]="menuModel.announceItemIsSelected && item.ariaSelected"
            [attr.aria-checked]="menuModel.announceItemIsSelected && item.ariaChecked"
            #menuItem>
            <ng-container *ngIf="menuItemTemplate">
                <ng-template [ngTemplateOutlet]="menuItemTemplate"
                             [ngTemplateOutletContext]="{
                                 item: item,
                                 index: idx}">
                </ng-template>
            </ng-container>
            <!-- TODO: Support default menu item UI and remove from context-menu.component & actions-menu.component-->
            <!--<div *ngIf="!menuItemTemplate" class="actions-menu-item__flex-content">
                <ohp-icon-font [iconFontType]="item.icon" [iconFontCssClass]="item.iconCssClass" size="16" [color]="item.iconColor" cssClass="actions-menu-item__icon"></ohp-icon-font>
                <div class="list-item__title menu-item__title">{{ item.title }}</div>
            </div>-->
        </li>
    </ul>
</div>
